import "../../App.css";
import "./Contact.css";

const Contact = () => {

    const address = "Podlužany 79,\n935 27, Podlužany\nSlovensko";

    return(
        <div className="contacts">
            <div className="container">
                <h1>Kontakty</h1>

                <div className="grid">
                    <div className="contact-info">
                        

                        <h3>Telefónne čísla:</h3>
                        <ul class="p-2">
                            <li><i class="fas fa-mobile-alt"></i> +421 905 811 685</li>
                            <li><i class="fas fa-mobile-alt"></i> +421 903 351 671</li>
                        </ul>
                        <h3>Email:</h3>
                        <ul class="p-2">
                            <li><i class="far fa-envelope"></i> adosvita@gmail.com</li>
                        </ul>
                        <h3>Adresa:</h3>
                        <i class="fas fa-map-marker-alt"></i>
                        <p className="addr">
                            {address}
                        </p>


                    </div>
                    <div className="map">
                        <iframe width="100%" height="100%" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"
                        title="Google Map showing Podlužany location"
                        src="https://maps.google.sk/maps?f=q&amp;source=s_q&amp;hl=sk&amp;geocode=&amp;q=93527+Podlu%C5%BEany&amp;aq=&amp;sll=48.758678,18.280735&amp;sspn=0.081705,0.137844&amp;g=Podlu%C5%BEany&amp;ie=UTF8&amp;hq=&amp;hnear=Podlu%C5%BEany&amp;ll=48.254281,18.606773&amp;spn=0.041265,0.068922&amp;t=m&amp;z=12&amp;output=embed">
                        </iframe>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Contact;